import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss']
})
export class SingleSelectComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() data: any;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() values: any[] = [];

  @Output() result: EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild('multiple') multiple: MatSelect;
  @ViewChild(CdkVirtualScrollViewport) cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  initialRange = { start: 0, end: 10 };

  public bankMultiCtrl: FormControl = new FormControl();

  public matSelectSearchCtrl: FormControl = new FormControl();

  public filteredData: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  protected onDestroy = new Subject<void>();
  public model: any[] = [];
  countdownTimeoutIndex: any;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    // listen for search field value changes
    this.matSelectSearchCtrl.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.countdownTimeoutIndex) {
          clearTimeout(this.countdownTimeoutIndex);
        }
        this.countdownTimeoutIndex = setTimeout(() => {
          this.filterMulti();
        }, 1000);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.filteredData.next(this.data.slice());
      if (this.values.length === this.data.length) {
        this.model = this.data;
      } else {
        this.model = this.values;
      }
    }
  }

  ngAfterViewInit() {
    if(this.multiple){
      Object.defineProperty(this.multiple, 'empty', {
        get: ()=> !(this.model.length > 0),
        configurable: true
      });
    }
    this.setInitialValue();
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  optionChanges(option) {
    this.model = [option.value];
  }

  setInitialValue() {
    this.filteredData
      .pipe(take(1), takeUntil(this.onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiple.compareWith = (a: any, b: any) => a && b && a.name === b.name;
      });
  }

  scrolledIndexChange($event) {
    if (!this.initialRange) {
      this.initialRange = this.cdkVirtualScrollViewport.getRenderedRange();
    }

  }

  filterMulti() {
    if (!this.data) {
      return;
    }
    // get the search keyword
    let search = this.matSelectSearchCtrl.value;
    if (!search) {
      this.filteredData.next(this.data.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredData.next(
      this.data.filter(item => item.name.toLowerCase().indexOf(search) > -1)
    );
  }

  openedChange(opened: boolean) {
    if (!opened) {
      this.result.emit(this.model);
      this.cdkVirtualScrollViewport.setRenderedContentOffset(0);
      this.cdkVirtualScrollViewport.setRenderedRange(this.initialRange);

      (this.multiple as any).isEmpty = !this.model || this.model.length === 0;
    }
  }

  // isSelect(option: MatOption) {
  //   if (this.model.findIndex(item => item.value === option.value.value) !== -1) {
  //     option.select();
  //   } else {
  //     option.deselect();
  //   }
  // }

  getNames() {
    return this.model.map(x => x.name).toString();
  }

}
